module.exports = __webpack_public_path__ + "media/images/logo-navbar-77505093d52b797bc470892c25f996a8.png";